import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, Data, LogsData, NewOrderData, BillData } from './types'

export const selectListEvent = (state: RootState): Event => state.orderReducer.listEvent

export const selectList = (state: RootState): ListData => state.orderReducer.list

export const selectActionEvent = (state: RootState): Event => state.orderReducer.actionEvent

export const selectDetail = (state: RootState): Data | undefined => state.orderReducer.detail

export const selectDetailEvent = (state: RootState): Event => state.orderReducer.detailEvent

export const selectLogs = (state: RootState): LogsData[] => state.orderReducer.logs

export const selectLogsEvent = (state: RootState): Event => state.orderReducer.logsEvent

export const selectNewOrder = (state: RootState): NewOrderData | undefined => state.orderReducer.newOrder

export const selectPosBill = (state: RootState): BillData | undefined => state.orderReducer.posBill.data

export const selectUpdateTerminalStatusEvent = (state: RootState): Event =>
  state.orderReducer.updateTerminalStatusEvent

export const selectUpdateOrderAddressEvent = (state: RootState): Event =>
  state.orderReducer.updateOrderAddressEvent

export const selectUpdatePaymentEvent = (state: RootState): Event => state.orderReducer.updatePaymentTypeEvent
